var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-button',{staticClass:"login-button",attrs:{"hover":true}},[_c('span',[_vm._v("MENU")])])
}
var staticRenderFns = []

export { render, staticRenderFns }